import { DrawerComponent } from "../_metronic/assets/ts/components";

export type BookingDrawerSource =
  | "default"
  | "quick-quotes"
  | "annuity-quotes"
  | "dashboard";

export type BookingDrawerAction = {
  label: string;
  to: string;
  className?: string;
  iconClassName?: string;
};

export type BookingDrawerConfig = {
  source?: BookingDrawerSource;
  completionActions?: BookingDrawerAction[];
};

type BookingDrawerState = {
  config: BookingDrawerConfig;
  version: number;
};

const DEFAULT_BOOKING_DRAWER_CONFIG: Required<BookingDrawerConfig> = {
  source: "default",
  completionActions: [
    {
      label: "View my booking",
      to: "/overview?tab=ifa-call-booking",
      className: "btn btn-primary",
      iconClassName: "ki-duotone ki-arrow-right fs-2 text-warning",
    },
  ],
};

let bookingDrawerState: BookingDrawerState = {
  config: DEFAULT_BOOKING_DRAWER_CONFIG,
  version: 0,
};

const bookingDrawerListeners = new Set<() => void>();

export function getBookingDrawerState() {
  return bookingDrawerState;
}

export function subscribeToBookingDrawerState(listener: () => void) {
  bookingDrawerListeners.add(listener);

  return () => {
    bookingDrawerListeners.delete(listener);
  };
}

function setBookingDrawerConfig(config?: BookingDrawerConfig) {
  bookingDrawerState = {
    config: {
      ...DEFAULT_BOOKING_DRAWER_CONFIG,
      ...config,
      completionActions:
        config?.completionActions ??
        DEFAULT_BOOKING_DRAWER_CONFIG.completionActions,
    },
    version: bookingDrawerState.version + 1,
  };

  bookingDrawerListeners.forEach((listener) => listener());
}

export function openDrawer(id: string) {
  DrawerComponent.getInstance(`${id}_drawer`)?.show();
}

export function openBookingDrawer(config?: BookingDrawerConfig) {
  setBookingDrawerConfig(config);
  openDrawer("booking");
}

export function openLifetimeAnnuityDrawer() {
  openDrawer("whatIsALifeTimeAnnuity");
}

export function openFixedTermAnnuityDrawer() {
  openDrawer("whatIsAFixedTermAnnuity");
}

export function openFlexibleAccessDrawdownDrawer() {
  openDrawer("whatIsFlexibleAccessDrawdown");
}
